module.exports = __webpack_public_path__ + "img/50C.5690f309.png";